module.exports = __webpack_public_path__ + "static/media/Carlos_Javier_Sanchez_Mancilla.3e8e4836.jpg";